import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable no-empty */
import { Endpoints } from './Constants';
import RequestHelper from './RequestHelper';
import Utils from '../utils';
import { EVENT_TYPES } from '../lib/analytics/constants';
import Logger from '../lib/analytics/logger';
/** @typedef {import('./Constants').KYCCheckInfo} KYCCheckInfo */

export default {
  /**
   * Helper Method to send server request to get a player's profile
   * @async
   * @public
   * @returns {Object} Player profile object server returns
   */
  getPlayerProfile: function () {
    var _getPlayerProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var callResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return RequestHelper.apiGet({
                endpoint: Endpoints.GET_PLAYER_PROFILE
              }, true);

            case 3:
              callResponse = _context.sent;

              if (!(callResponse.success === false)) {
                _context.next = 6;
                break;
              }

              throw Error("[Get-Player-Profile-response] ".concat(callResponse.error));

            case 6:
              callResponse.emailOptIn = callResponse.emailOptIn === 'yes';
              return _context.abrupt("return", callResponse);

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    }));

    function getPlayerProfile() {
      return _getPlayerProfile.apply(this, arguments);
    }

    return getPlayerProfile;
  }(),
  updatePlayerProfile: function () {
    var _updatePlayerProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
      var callResponse;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.UPDATE_PLAYER_PROFILE,
                body: _objectSpread({}, params)
              }, true);

            case 3:
              callResponse = _context2.sent;

              if (!(callResponse.success === false)) {
                _context2.next = 6;
                break;
              }

              throw Error("[Update-Player-Profile-response] ".concat(callResponse.error));

            case 6:
              return _context2.abrupt("return", callResponse);

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9]]);
    }));

    function updatePlayerProfile(_x) {
      return _updatePlayerProfile.apply(this, arguments);
    }

    return updatePlayerProfile;
  }(),

  /**
   * Helper method to get player extra.
   * Currently this just calls getPlayerProfile.
   * Edit this in the future if we find a lighter call.
   */
  getPlayerExtras: function () {
    var _getPlayerExtras = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return this.getPlayerProfile();

            case 3:
              _context3.next = 7;
              break;

            case 5:
              _context3.prev = 5;
              _context3.t0 = _context3["catch"](0);

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 5]]);
    }));

    function getPlayerExtras() {
      return _getPlayerExtras.apply(this, arguments);
    }

    return getPlayerExtras;
  }(),
  deDupeCheck: function () {
    var _deDupeCheck = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
      var deDupeResponse;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return RequestHelper.apiPost({
                endpoint: Endpoints.DE_DUPE_CHECK,
                body: _objectSpread({
                  platform: Utils.getPlatform()
                }, params)
              });

            case 2:
              deDupeResponse = _context4.sent;
              return _context4.abrupt("return", deDupeResponse);

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function deDupeCheck(_x2) {
      return _deDupeCheck.apply(this, arguments);
    }

    return deDupeCheck;
  }(),

  /**
   * Helper method for know your customer
   * @async
   * @public
   * @param {KYCCheckInfo} params - User's KYC info
   */
  knowYourCustomer: function () {
    var _knowYourCustomer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params) {
      var kycResponse;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return RequestHelper.apiPost({
                endpoint: Endpoints.KYC_CHECK,
                body: _objectSpread({
                  platform: Utils.getPlatform()
                }, params)
              });

            case 2:
              kycResponse = _context5.sent;
              return _context5.abrupt("return", kycResponse);

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function knowYourCustomer(_x3) {
      return _knowYourCustomer.apply(this, arguments);
    }

    return knowYourCustomer;
  }(),
  kycUpload: function () {
    var _kycUpload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(formData) {
      var kycUploadResponse;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return RequestHelper.apiPost({
                endpoint: Endpoints.KYC_UPLOAD,
                body: formData,
                isBinary: true,
                useDefaultHeaders: ['gtp-app-id', 'gtp-property-id', 'Authentication']
              });

            case 2:
              kycUploadResponse = _context6.sent;
              return _context6.abrupt("return", kycUploadResponse);

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function kycUpload(_x4) {
      return _kycUpload.apply(this, arguments);
    }

    return kycUpload;
  }(),

  /**
   * Helper method get getting the player's casino dollar balance
   * @async
   * @public
   */
  getCasinoDollarBalance: function () {
    var _getCasinoDollarBalance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var cdBalanceResponse;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return RequestHelper.apiGet({
                endpoint: Endpoints.GET_CASINO_DOLLAR_BALANCE
              });

            case 2:
              cdBalanceResponse = _context7.sent;
              return _context7.abrupt("return", cdBalanceResponse);

            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    function getCasinoDollarBalance() {
      return _getCasinoDollarBalance.apply(this, arguments);
    }

    return getCasinoDollarBalance;
  }(),
  toggleSound: function () {
    var _toggleSound = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var response;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return RequestHelper.apiGet({
                endpoint: Endpoints.TOGGLE_SOUND
              }, true);

            case 2:
              response = _context8.sent;
              return _context8.abrupt("return", response);

            case 4:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    function toggleSound() {
      return _toggleSound.apply(this, arguments);
    }

    return toggleSound;
  }(),
  toggleMusic: function () {
    var _toggleMusic = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var response;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return RequestHelper.apiGet({
                endpoint: Endpoints.TOGGLE_MUSIC
              }, true);

            case 2:
              response = _context9.sent;
              return _context9.abrupt("return", response);

            case 4:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    function toggleMusic() {
      return _toggleMusic.apply(this, arguments);
    }

    return toggleMusic;
  }(),
  changePassword: function () {
    var _changePassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref) {
      var newPassword, oldPassword, response, eventPayload;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              newPassword = _ref.newPassword, oldPassword = _ref.oldPassword;
              _context10.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.CHANGE_PASSWORD,
                body: {
                  oldPassword: oldPassword,
                  newPassword: newPassword,
                  platform: Utils.getPlatform(),
                  useDefaultHeaders: ['gtp-app-id', 'gtp-property-id', 'Authentication']
                }
              }, true);

            case 3:
              response = _context10.sent;

              if (!response.success) {
                eventPayload = {
                  description: "Change password failed, ".concat(response.error),
                  code: response.error_code
                };
                Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
              }

              return _context10.abrupt("return", response);

            case 6:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    function changePassword(_x5) {
      return _changePassword.apply(this, arguments);
    }

    return changePassword;
  }(),
  recoverPasswordTokenCheck: function () {
    var _recoverPasswordTokenCheck = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref2) {
      var id, token, response, eventPayload;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              id = _ref2.id, token = _ref2.token;
              _context11.prev = 1;
              _context11.next = 4;
              return RequestHelper.apiPost({
                endpoint: Endpoints.RECOVER_PASSWORD_TOKEN_CHECK,
                body: {
                  id: id,
                  token: token
                }
              });

            case 4:
              response = _context11.sent;

              if (!response.success) {
                eventPayload = {
                  description: "Check recover password failed, ".concat(response.error),
                  code: response.error_code
                };
                Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
              }

              return _context11.abrupt("return", response);

            case 9:
              _context11.prev = 9;
              _context11.t0 = _context11["catch"](1);

            case 11:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[1, 9]]);
    }));

    function recoverPasswordTokenCheck(_x6) {
      return _recoverPasswordTokenCheck.apply(this, arguments);
    }

    return recoverPasswordTokenCheck;
  }(),
  recoverPassword: function () {
    var _recoverPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref3) {
      var id, token, password, response, eventPayload;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              id = _ref3.id, token = _ref3.token, password = _ref3.password;
              _context12.prev = 1;
              _context12.next = 4;
              return RequestHelper.apiPost({
                endpoint: Endpoints.RECOVER_PASSWORD,
                body: {
                  id: id,
                  token: token,
                  password: password
                }
              });

            case 4:
              response = _context12.sent;

              if (!response.success) {
                eventPayload = {
                  description: "Check recover password failed, ".concat(response.error),
                  code: response.error_code
                };
                Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
              }

              return _context12.abrupt("return", response);

            case 9:
              _context12.prev = 9;
              _context12.t0 = _context12["catch"](1);

            case 11:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[1, 9]]);
    }));

    function recoverPassword(_x7) {
      return _recoverPassword.apply(this, arguments);
    }

    return recoverPassword;
  }(),
  acceptNewTerms: function () {
    var _acceptNewTerms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(params) {
      var response;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              _context13.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.ACCEPT_NEW_TERMS,
                body: _objectSpread({}, params)
              });

            case 3:
              response = _context13.sent;
              return _context13.abrupt("return", response);

            case 7:
              _context13.prev = 7;
              _context13.t0 = _context13["catch"](0);

            case 9:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, null, [[0, 7]]);
    }));

    function acceptNewTerms(_x8) {
      return _acceptNewTerms.apply(this, arguments);
    }

    return acceptNewTerms;
  }(),
  deletePlayerAccount: function () {
    var _deletePlayerAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(params) {
      var response;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              _context14.next = 3;
              return RequestHelper.apiGet({
                endpoint: Endpoints.DELETE_PLAYER_ACCOUNT,
                body: _objectSpread({}, params)
              });

            case 3:
              response = _context14.sent;
              return _context14.abrupt("return", response);

            case 7:
              _context14.prev = 7;
              _context14.t0 = _context14["catch"](0);

            case 9:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, null, [[0, 7]]);
    }));

    function deletePlayerAccount(_x9) {
      return _deletePlayerAccount.apply(this, arguments);
    }

    return deletePlayerAccount;
  }()
};